










































































import Vue from "vue";
import { mapState } from "vuex";
import { RootState } from "@/store/types";

import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import FloatingMenu from "@/components/Molecules/FloatingMenu/index.vue";
import FloatingMenuTitle from "@/components/Atoms/FloatingMenuItems/FloatingMenuTitle/index.vue";
import FloatingMenuCheckButton from "@/components/Atoms/FloatingMenuItems/FloatingMenuCheckButton/index.vue";
import EditPlanView from "../EditPlanView";
import { isOuterElementClicked } from "@/helpers/vue-helper";
import { Data, Computed, Props, Methods, ProjectHeaderEvent } from "./types";
import { KEYCODE } from "@/constants/event";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Heading,
    FloatingMenu,
    FloatingMenuTitle,
    FloatingMenuCheckButton,
    Body,
    Button,
    ButtonConfig,
    EditPlanView
  },
  props: {
    graduateYear: {
      type: Number,
      required: true
    },
    planName: {
      type: String,
      required: true
    },
    planPeriod: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      isFloatingMenuVisible: false,
      timeLineMagnificationTerm: {
        shortTerm: 1.81,
        middleTerm: 1,
        longTerm: 0.63
      }
    };
  },
  computed: {
    ...mapState<RootState>({
      isEditPlanViewVisible: (state: RootState) =>
        state.pages.plan.isEditPlanViewVisible,
      planSettings: (state: RootState) => state.pages.plan.planSettings,
      planId: (state: RootState) => state.pages.plan.applicationPlan!.id
    }),
    title() {
      if (!this.graduateYear) {
        return "";
      }
      return `${this.graduateYear}年卒 ${this.planName}`;
    },
    floatingMenuCheckButtonItems() {
      return [
        {
          value: "showShortTerm",
          label: "拡大",
          checked:
            this.planSettings.timeLineMagnification ===
            this.timeLineMagnificationTerm.shortTerm
        },
        {
          value: "showMiddleTerm",
          label: "標準",
          checked:
            this.planSettings.timeLineMagnification ===
            this.timeLineMagnificationTerm.middleTerm
        },
        {
          value: "showLongTerm",
          label: "縮小",
          checked:
            this.planSettings.timeLineMagnification ===
            this.timeLineMagnificationTerm.longTerm
        }
      ];
    }
  },
  mounted() {
    window.addEventListener("click", this.handleWindowClick);
    window.addEventListener("keyup", this.handlePressEsc);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleWindowClick);
    window.removeEventListener("keyup", this.handlePressEsc);
  },
  methods: {
    handleWindowClick(event) {
      const $titleArea = this.$refs.titleArea as Element;
      const $editPlanView = this.$refs.editPlanView as Vue;

      if ($titleArea && $editPlanView) {
        const isOuterEditPlanViewClicked = isOuterElementClicked(
          event.target,
          $titleArea,
          $editPlanView.$el
        );
        if (isOuterEditPlanViewClicked) {
          this.$emit("editPlanViewClose");
        }
      }
    },
    handleClickEditPlanViewOpen() {
      this.$emit("clickEditPlanViewOpen");
    },
    handleEditPlanViewChange(event) {
      this.$emit("change", {
        plan: event
      } as ProjectHeaderEvent);
    },
    handleClickCreateEventViewOpen() {
      this.$emit("clickCreateEventViewOpen");
    },
    toggleChangeTimeLineSizeViewOpen() {
      this.isFloatingMenuVisible = !this.isFloatingMenuVisible!;
    },
    handleFloatingMenuEvent(value) {
      switch (value) {
        case "showShortTerm": {
          this.$emit(
            "clickChangeTimeLineMagnification",
            this.timeLineMagnificationTerm.shortTerm
          );
          break;
        }
        case "showMiddleTerm": {
          this.$emit(
            "clickChangeTimeLineMagnification",
            this.timeLineMagnificationTerm.middleTerm
          );
          break;
        }
        case "showLongTerm": {
          this.$emit(
            "clickChangeTimeLineMagnification",
            this.timeLineMagnificationTerm.longTerm
          );
          break;
        }
      }
    },
    handleEventClickMenu(value) {
      this.handleFloatingMenuEvent(value);
      this.isFloatingMenuVisible = false;
    },
    handlePressEsc(event) {
      if (event.keyCode === KEYCODE.ESC && this.isFloatingMenuVisible) {
        this.isFloatingMenuVisible = false;
      }
    }
  }
});
